import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { StateService } from '@app/core/services/state.service';
import { EconomyService, PriceListItem } from '@app/services/economy.service';

@Component({
    selector: 'tt-campaign-edit',
    templateUrl: './campaign-edit.component.html',
    styleUrls: ['./campaign-edit.component.css'],
    standalone: false
})
export class CampaignEditComponent implements OnInit {
    public campaignKeyno: string;

    public page?: CampaignEditGet;

    public selectListPrices: PriceListItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService, private economy: EconomyService) {
        this.campaignKeyno = this.stateService.getStateParams()['campaign_keyno'];
    }

    private async loadPage() {
	    if (!!this.campaignKeyno) {
		    this.page = (await this.datatask.Post(1952, { campaign_keyno: this.campaignKeyno }))[0];
	    }
    }

    private async loadPrices() {
	    this.selectListPrices = await this.economy.getPriceLists();
    }

    public async saveChanges() {
	    if (!!this.page) {
		    try {
			    this.saving = true;
			    
			    await this.datatask.Post(1958, this.page);
						
			    this.stateService.back();
		    } finally {
			    this.saving = false;
		    }
	    }
    }
	
    private async init() {
	    await this.loadPage();
        this.loadPrices();
    }

    ngOnInit() {
	    this.init();
    }
}

interface CampaignEditGet {
    campaign_keyno: string;
    campaign_name: string;
    campaign_description: string;
    campaign_start: string;
    campaign_end: string;
    campaign_registered: string;
    campaign_pricelist_id: string;
}
